export enum SuppliesDiscountType {
  AmountOff = "amount_off",
}
